import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'mensual'
})
export class MonthlyPaymentPipe implements PipeTransform {

    transform(value: number, numberOfMonths: number, r: number): number {
        const rate = r ? r : 0.010214166666666665;
        numberOfMonths = numberOfMonths - 2;
        const newMonths = numberOfMonths + 1;
        const interestAmount = value + (value * rate * 2);
        const rPlus = 1 + rate;
        return ((interestAmount * Math.pow(rPlus, numberOfMonths)) * rate)
            / (Math.pow(rPlus, newMonths) - 1);
    }
}
